import { Button, Col, Image, Row } from "antd";
import CalendarOutlined from "@ant-design/icons/lib/icons/CalendarOutlined";
import { useState } from "react";
import usePageState from "../../../../hooks/usePageState";
import { SALE_TYPE_ENUM } from "../../../../../applications/constants/AppConst";
import { SaleInfoModel } from "../../../../../infrastructure/model/SaleInfoModel";
import BaseDialog from "../../../../components/BaseDialog";
import LoadingPage from "../../../../components/LoadingPage";
import { useSaleInfoContext } from "../../../../context/AppSaleInfoContext";
import { formatRecurringDays } from "../../../../../applications/utils/TimeUtils";
import "../styles/FlashDeal.scss";
import { getAllSaleInfoUseCase } from "../../../../../applications/useCase/ApiUseCase/SaleApiUseCase";

interface FlashDealPageProps {}

function FlashDealPage(props: FlashDealPageProps) {
  const { saleInfo } = useSaleInfoContext();
  const [itemDetail, setItemDetail] = useState<SaleInfoModel>();
  const [isSaleOrder, setIsSaleOrder] = useState<number>();
  const { isLoading, setLoading, showError } = usePageState();
  const [saleInfoState, setSaleInfoState] = useState<SaleInfoModel[]>(saleInfo || []);

  const [touchStartY, setTouchStartY] = useState<number | null>(null);
  const [isScrolling, setIsScrolling] = useState(false);

  async function filterSaleInfor(filterSaleOrder?: number) {
    if (filterSaleOrder === isSaleOrder) {
      setIsSaleOrder(undefined);
      setSaleInfoState(saleInfo || []);
      return;
    }
    setIsSaleOrder(filterSaleOrder);
    const res = await getAllSaleInfoUseCase({
      page: 1,
      limit: 30,
      is_sale_order: filterSaleOrder === undefined ? undefined : filterSaleOrder === 0,
      setLoading,
      showError,
    });
    if (res) {
      setSaleInfoState(res.data);
    }
  }

  const renderSaleTime = (itemSale: SaleInfoModel) => {
    if (itemSale.is_recurring) {
      return <div>Áp dụng vào {formatRecurringDays(itemSale.recurring_days)}</div>;
    }
    return (
      <div>
        <Button icon={<CalendarOutlined />} type="text">
          {new Date(itemSale.sale_start_date).toLocaleDateString("vi-VN")}
        </Button>
        &nbsp; - &nbsp;
        <Button icon={<CalendarOutlined />} type="text">
          {new Date(itemSale.sale_end_date).toLocaleDateString("vi-VN")}
        </Button>
      </div>
    );
  };

  return (
    <div style={{ position: "relative" }} className="main-products">
      <div
        className="sale-page-wrapper"
        style={{
          padding: "4px 8px",
          boxSizing: "border-box",
        }}
      >
        <Row gutter={[24, 24]} className="sale-list-items">
          {isLoading ? (
            <Col span={24}>
              <div
                style={{
                  width: "100%",
                  height: "40vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoadingPage />
              </div>
            </Col>
          ) : (
            saleInfoState?.map((item) => (
              <Col
                key={item.id}
                xs={24} // Mobile: 1 item
                sm={12} // Tablet: 2 items
                md={8} // Laptop: 3 items
                xl={6} // Desktop lớn: 4 items
                className="sale-card"
                onTouchStart={(e) => {
                  setTouchStartY(e.touches[0].clientY);
                  setIsScrolling(false);
                }}
                onTouchMove={(e) => {
                  if (touchStartY !== null) {
                    const diff = Math.abs(e.touches[0].clientY - touchStartY);
                    if (diff > 10) {
                      setIsScrolling(true);
                    }
                  }
                }}
                onTouchEnd={() => {
                  if (!isScrolling) {
                    setItemDetail(item); // chỉ mở khi tap
                  }
                  setTouchStartY(null);
                }}
                onClick={() => {
                  // vẫn cho desktop click
                  setItemDetail(item);
                }}
              >
                <div className="sale-card-inner">
                  <div className="sale-image">
                    <Image
                      preview={false}
                      src={item.thumbnail}
                      // alt={item.title}
                      className="sale-img"
                    />

                    <div className="sale-image-overlay" />

                    <span className={`sale-badge sale-${item.sale_type}`}>
                      {item.sale_type === SALE_TYPE_ENUM.ALL_BILL
                        ? "Đơn hàng"
                        : item.sale_type === SALE_TYPE_ENUM.EACH_ITEM
                        ? "Sản phẩm"
                        : "Combo"}
                    </span>
                  </div>

                  <div className="sale-content">
                    <h3 className="sale-item-title">{item.title}</h3>
                    <div className="sale-time">{renderSaleTime(item)}</div>
                  </div>
                </div>
              </Col>
            ))
          )}
        </Row>
      </div>

      {itemDetail && (
        <BaseDialog
          width={"60vw"}
          className="flashdeal-dialog"
          title={itemDetail.title}
          footer={[
            <Button key="cancel" onClick={() => setItemDetail(undefined)}>
              Đóng
            </Button>,
          ]}
        >
          <div style={{ fontWeight: "600" }}>
            {itemDetail.sale_type === SALE_TYPE_ENUM.ALL_BILL
              ? "Khuyến mãi áp dụng cho đơn hàng"
              : itemDetail.sale_type === SALE_TYPE_ENUM.EACH_ITEM
              ? "Khuyến mãi áp dụng cho sản phẩm"
              : "Khuyến mãi áp dụng cho combo"}
          </div>
          <div className="mb-2 flex mt-2">
            Thời gian áp dụng khuyến mãi: &nbsp; &nbsp;{renderSaleTime(itemDetail)}
          </div>
          <div>
            <Image
              src={itemDetail?.thumbnail}
              alt="Sale Thumbnail"
              width="100%"
              height={300}
              preview={false}
            />
          </div>
          <div>{itemDetail.content}</div>
        </BaseDialog>
      )}
    </div>
  );
}
export default FlashDealPage;
